export default __webpack_public_path__ + "static/media/governance.13d65f3a.png";